/**
 * @file Describe the file
 */

export default class myUtils {

    static debounce(func, wait) {
        let timeout;
        return function(event) {
            let _this = this
            let args = arguments;
            if (timeout) {
                clearTimeout(timeout)
            }
            timeout = setTimeout(() => {
                timeout = null
                func.call(_this, args)
            }, wait)
        }
    }

    // 补零 num：要改变的值，len补零后数字的长度
    static addZero(num, len) {
        return String(num).length > len ? num : (Array(len).join(0) + num).slice(-len);
    }
}


// WEBPACK FOOTER //
// ./src/myUtils.js